module.exports = {"pageTitleText":"任务查找","submitTime":"提交时间","errorMsg":"错误信息","finishedTime":"完成时间","state":"处理状态","taskNo":"单号","trainNo":"车号","runCounter":"运行次数","scopeResult":"部署结果","scope":"影响范围","requestData":"修改资料","originData":"原始资料","diffData":"比较","objId":"物件 ID","decodeObjId":"物件名称","request_source":"请求来源","actionName":"操作名称"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/tasks.json
// module id = Nesp
// module chunks = 3